import { SINGLE_LINE_CARD_MIN_HEIGHT_GRID_UNITS } from '../../../common/cards/cardConstants';

export const LINK_PREVIEW_SIZE = { width: 676, height: 380 };
export const LINK_NO_PREVIEW_MIN_HEIGHT = SINGLE_LINE_CARD_MIN_HEIGHT_GRID_UNITS;
export const LINK_TITLE_EDITOR_KEY = 'LINK_TITLE';
